import React from 'react';
import { Toast, Toggle } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t,
  tf
} = I18N.ns('apiAccessKeyManagement.action.ToggleApiAccessKey');
export default {
  id: 'apiAccessKeyManagement.action.ToggleApiAccessKey',
  name: tf('name'),
  matches: {
    use: 'preActionsColumnBar',
    client: 'ApiAccessKeys'
  },
  prepare: async context => {
    const {
      clientProps: {
        actions,
        dispatch
      },
      item
    } = context;
    return dispatch(actions.apiAccessKey(item.id).canUpdate());
  },
  isPrepared: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return typeof allowed.updateApiAccessKey === 'boolean';
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return allowed.updateApiAccessKey === true;
  },
  customComponent: ({
    context
  }) => {
    const {
      item,
      clientProps: {
        actions,
        dispatch
      }
    } = context;
    return /*#__PURE__*/React.createElement(Toggle, {
      value: item.active,
      onChange: () => {
        dispatch(actions.apiAccessKey(item.id).update({
          active: !item.active
        })).then(res => {
          Toast.success([t(`apiAccessKeyActive_${!item.active}`)]);
        }).catch(() => {
          Toast.error([t(`apiAccessKeyActive_${!item.active}_error`)]);
        });
      }
    });
  }
};